import React, { useCallback, useEffect, useState }  from 'react'
import { useHistory, useParams } from 'react-router-dom'
import  { groupBy } from 'lodash'
import WizardHeader from 'components/VirtualPortal/components/WizardHeader'
import LoadingScreen from 'components/VirtualPortal/components/LoadingScreen'
import './availability.css'

const Availability = () => {
  const params = useParams()
  const history = useHistory()
  const { token } = params
  const [ state, setState ] = useState({
    isRefreshing: true,
    saving: false,
    timeslots: [],
    p2pDates: []
  })

  const getTimeslots = () => {
    window.api.get('/virtual_portal/event_session_one_on_one_timeslots').then((response) => {
      setState({ 
        ...state, 
        isRefreshing: false,
        timeslots: groupBy(response?.data?.event_session_one_on_one_timeslots, 'event_date'),
        p2pDates: Object.keys(groupBy(response.data.event_session_one_on_one_timeslots, 'event_date'))
      })
    })
  }

  useEffect(() => {
    getTimeslots()
  },[])

  const getDay = useCallback((date) => {
    const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    const dateObj = new Date(date)
    return days[dateObj.getDay()]
  },[])

  const toggleTimeslot = useCallback((date, index) => {
    const key = state.timeslots[date][index]

    if(key.opt_out_id) {
      window.api.delete('/virtual_portal/event_session_one_on_one_timeslot_survey_user_opt_outs/' + key.opt_out_id).then(() => {
        getTimeslots()
      })
    } else {
      // ADD
      const data = {
        event_session_one_on_one_timeslot_survey_user_opt_out: {
          event_session_one_on_one_timeslot_id: key.id
        }
      }
      window.api.post('/virtual_portal/event_session_one_on_one_timeslot_survey_user_opt_outs', data).then((response) => {
        if(response.status === 200){
          getTimeslots()
        }
      })
    }
  }, [state])

  const submit = useCallback((direction) => {
    setState({...state, saving: true })
    window.api.post('/virtual_portal/complete_event_one_on_one_meeting_wishlists').then(() => {
      let endpoint = params.wizard ? '/thankyou' : ''
      if(direction === 'forward'){
        if(window.visitingOneOnOneWizardFrom) {
          if(window.visitingOneOnOneWizardFrom == 'web') {
            // coming from webapp
            history.push('/' + token + '/thankyouweb')
          } else {
            // Coming from RN app.
            history.push('/' + token + endpoint)
          }
        } else {
          history.push('/' + token + endpoint)
        }
      } else {
        history.push('/' + token + '/wishlist_rank/wizard')
      }
    }).catch(() => {
      setState({...state, saving: false})
    })
  }, [state, history, params, token])

  if(window.LiveChatWidget) {
    if(params.wizard) {
      window.LiveChatWidget.call('hide')
    } else {
      window.LiveChatWidget.call('minimize')
    }
  }

  return(
    <div className='availability-page wizard-form'>
      <WizardHeader
        wizard={params.wizard}
        activeTab='availability' />
      { state.isRefreshing ? <LoadingScreen /> : '' }
      <h3>Please indicate your availability</h3>
      <p>The checked time slots indicate that you are available. Please deselect the time slots for which you are unavailable for peer-to-peer meetings at the {window.currentEvent.website_display_name}. If your schedule changes, you will be able to update your availability through the portal.</p>
      <div className='timeslots'>
        {state.p2pDates.length &&
          state.p2pDates.map((date, index) => {
            return (
              <div key={index}>
                <h3 className='center'>{getDay(date)} - {date}</h3>

                {state.timeslots[date].map((date, index) => {
                  return (
                    <div onClick={ () => toggleTimeslot(date.event_date, index) } key={index} className={`buttons opt-out-${date.opt_out_id ? 'true' : 'false' }`}>
                      <div>
                        <i className={date.opt_out_id ? '' : 'fa fa-check-circle' }></i> {date.time_block_formatted_start_time} - {date.time_block_formatted_end_time}
                      </div>
                    </div>
                  )
                })}

              </div>
            )
          })
        }
      </div>
      <div className='bottom-buttons margin-top-40'>
        { params.wizard ?
          <button onClick={ () => submit('backward') } className='submit previous'>
              SAVE & PREVIOUS
          </button>
          : '' }
        <button
          disabled={state.saving}
          onClick={ () => submit('forward') }
          className={'submit'}>
          {state.saving ? (<i className="fa fa-refresh fa-spin red"></i>) : ''}
          { params.wizard ? 'SAVE & COMPLETE' : 'SAVE'}
        </button>
      </div>
    </div>
  )

}

export default Availability